import type React from "react";

import { SkeletonLayout } from "shared/atoms/SkeletonLayout";

export const EnrollmentGoalsSkeleton: React.FC = () => (
  <SkeletonLayout
    layout={{
      type: "column",
      spacing: 3,
      children: [
        {
          type: "column",
          spacing: 2,
          children: [
            { type: "skeleton", variant: "text", typographyVariant: "subtitle2", width: "40%" },
            {
              type: "row",
              spacing: 2,
              alignItems: "center",
              children: [
                {
                  type: "column",
                  width: "auto",
                  sx: { flex: 1 },
                  children: [{ type: "skeleton", variant: "rounded", height: 40, width: "100%" }],
                },
                { type: "skeleton", variant: "rounded", height: 40, width: 90 },
                { type: "skeleton", variant: "rounded", height: 40, width: 90 },
              ],
            },
          ],
        },
        { type: "skeleton", variant: "rectangular", height: 1, width: "100%" },
        {
          type: "column",
          spacing: 2,
          children: [
            { type: "skeleton", variant: "text", typographyVariant: "subtitle2", width: "35%" },
            { type: "skeleton", variant: "rounded", height: 40, width: "100%" },
          ],
        },
        { type: "skeleton", variant: "rectangular", height: 1, width: "100%" },
        {
          type: "column",
          spacing: 2,
          children: [
            {
              type: "row",
              spacing: 2,
              children: [
                {
                  type: "column",
                  width: "auto",
                  sx: { flex: 1 },
                  children: [{ type: "skeleton", variant: "rounded", height: 64, width: "100%" }],
                },
                {
                  type: "column",
                  width: "auto",
                  sx: { flex: 1 },
                  children: [{ type: "skeleton", variant: "rounded", height: 64, width: "100%" }],
                },
              ],
            },
            {
              type: "row",
              spacing: 2,
              children: [
                {
                  type: "column",
                  width: "auto",
                  sx: { flex: 1 },
                  children: [{ type: "skeleton", variant: "rounded", height: 64, width: "100%" }],
                },
                {
                  type: "column",
                  width: "auto",
                  sx: { flex: 1 },
                  children: [{ type: "skeleton", variant: "rounded", height: 64, width: "100%" }],
                },
              ],
            },
            { type: "skeleton", variant: "rounded", height: 40, width: "100%" },
          ],
        },
      ],
    }}
  />
);
